import _ from 'lodash'
import Generic from './generic'
import Card from './card'

const cardWrapper = (attributes) => new Card(attributes)

class Olympiad extends Generic {
  constructor(attributes) {
    super(attributes)

    this._trialCards = _.map(attributes.trial_cards, cardWrapper)
    this._mainCards = _.map(attributes.main_cards, cardWrapper)
    this._preparatoryCards = _.map(attributes.preparatory_cards, cardWrapper)
  }

  get shortName() { return this.translates(this.short_names) }
  get name() { return this.translates(this.names) }
  get programme() { return this.translates(this.programmes) }
  get trialCards() { return this._trialCards }
  get mainCards() { return this._mainCards }
  get preparatoryCards() { return this._preparatoryCards }
}

export default Olympiad
